export type SessionPayload = {
  user: {
    id: string;
    username: string;
    displayName: string;
    avatarUrl: string;
    bio: string;
    status: string;
    role: string;
    kind: string;
  } | null;
  guest: { guestId: string; displayName: string; avatarId: string } | null;
};

export type PublicSettings = {
  appName: string;
  tagline: string;
  logoUrl: string | null;
  theme: Record<string, string>;
  guestEnabled: boolean;
  maxMessageLength: number;
  welcomePublic: string;
  welcomeMembers: string;
};

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: "include",
    headers: { "content-type": "application/json", ...(init?.headers || {}) },
    ...init,
  });
  if (!res.ok) {
    let err = res.statusText;
    try {
      const j = (await res.json()) as { error?: string };
      err = j.error || err;
    } catch {
      /* ignore */
    }
    throw Object.assign(new Error(err), { status: res.status });
  }
  return res.json() as Promise<T>;
}

export const session = () => api<SessionPayload>("/api/auth/session");
export const publicSettings = () => api<PublicSettings>("/api/settings/public");
